import { BuiltInExteriorPropId } from "building-types/props/builtInExteriorPropId";
import { PropId } from "building-types/props/propIds";
import type { HomeSettings } from "building-types/settings/homeSettings";
import { SettingsType } from "building-types/settings/settingsType";
import { EaveType, FasciaTopTrimSize, WindowMullionType } from "building-types/settings/settingsTypesEnum";
import { defaultExteriorPropCatalog } from "../elements/propCatalog/exteriorPropCatalog";
import { fasciaTopTrimSizeToValue } from "../fasciaTopTrimSizeToValue";
import { BuiltinHomeSettingsId, builtinHomeSettingsPrettyName } from "./builtinHomeSettingsId";
import {
  defaultFarmhouseWindowSettings,
  defaultFriezeBoardSettings,
  defaultHomeSettings,
  defaultPorchSettings,
  defaultWainscotingSettings,
  defaultWindowTrimSettings,
  sharedSettingsDefaults,
} from "./defaultSettings";

const farmhouseSettings: { [id: string]: HomeSettings } = {
  [BuiltinHomeSettingsId.PaletteMF11]: {
    ...defaultHomeSettings,
    name: builtinHomeSettingsPrettyName[BuiltinHomeSettingsId.PaletteMF11],
    exteriorMaterials: {
      id: BuiltinHomeSettingsId.PaletteMF11 + "_exterior",
      type: SettingsType.EXTERIOR_MATERIAL_SETTINGS,
      palettes: [BuiltinHomeSettingsId.PaletteMF11],
    },
    roof: {
      type: SettingsType.ROOF_SETTINGS,
      eaveOverhang: 1,
      rakeOverhang: 1,
      shedOverhang: sharedSettingsDefaults.roofShedOverhang0,
      eaveType: EaveType.BOXED_BOX,
      includeFasciaTopTrim: true,
      fasciaTopTrimSize: fasciaTopTrimSizeToValue[FasciaTopTrimSize.TWO_INCH],
      eaveFasciaSize: 8,
      rakeFasciaSize: 8,
      rakeFriezeBoard: defaultFriezeBoardSettings,
      includeFriezeBoardOnPorches: true,
    },
    wainscoting: {
      ...defaultWainscotingSettings,
      height: 0,
    },

    ...defaultFarmhouseWindowSettings,
    ...defaultWindowTrimSettings,
    windowMullions: { type: SettingsType.WINDOW_MULLION_SETTINGS, mullionType: WindowMullionType.DISABLED },

    porch: {
      ...defaultPorchSettings,
    },
    exteriorProps: {
      type: SettingsType.EXTERIOR_PROP_SETTINGS,
      propTypes: {
        ...defaultExteriorPropCatalog,
        garageDoorSingle: {
          ...defaultExteriorPropCatalog[BuiltInExteriorPropId.GARAGEDOORSINGLE],
          propAssetId: PropId.DoorGar_S8x7_2x4Glass_01,
        },
        garageDoorDouble: {
          ...defaultExteriorPropCatalog[BuiltInExteriorPropId.GARAGEDOORDOUBLE],
          propAssetId: PropId.DoorGar_D16x7_2x4Glass_01,
        },
        doorDoubleGlass: {
          ...defaultExteriorPropCatalog[BuiltInExteriorPropId.DOORDOUBLEGLASS],
          propAssetId: PropId.DoorExt_Double30_02,
        },
        doorDoubleGlassLow: {
          ...defaultExteriorPropCatalog[BuiltInExteriorPropId.DOORDOUBLEGLASSLOW],
          propAssetId: PropId.DoorExt_Double30_01,
        },
        doorSingleGlass: {
          ...defaultExteriorPropCatalog[BuiltInExteriorPropId.DOORSINGLEGLASS],
          propAssetId: PropId.DoorExt_Single36_02,
        },
        doorSingleGlassLow: {
          ...defaultExteriorPropCatalog[BuiltInExteriorPropId.DOORSINGLEGLASSLOW],
          propAssetId: PropId.DoorExt_Single36_01,
        },
        exteriorLamp: {
          ...defaultExteriorPropCatalog[BuiltInExteriorPropId.EXTERIORLAMP],
          propAssetId: PropId.Lights_ExteriorWall_LanternTall_01,
        },
      },
    },
  },
};

export default farmhouseSettings;
